import { render, staticRenderFns } from "./jieguo.vue?vue&type=template&id=3998a62f&scoped=true"
import script from "./jieguo.vue?vue&type=script&lang=js"
export * from "./jieguo.vue?vue&type=script&lang=js"
import style0 from "./jieguo.vue?vue&type=style&index=0&id=3998a62f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3998a62f",
  null
  
)

export default component.exports